import React from 'react';

import classNames from 'classnames';

import './index.scss';

const MutateTipPionLegend = ({ comonent: Component = 'div', ...props }) => (
  <Component
    {...props}
    className={classNames('mutate-tip-pion-legend', props.className)}
  >
    {props.children}
  </Component>
);

export default MutateTipPionLegend;
